import { Capacitor } from '@capacitor/core';
import { isSafeHttpUrl } from '../../../core/utils/isSafeHttpUrl';
import { openExternalMenuLink } from './openExternalMenuLink';

// `target='_blank'` can strand the user in a chromeless view on native, so the host opens it.
export const handleExternalMenuClick = (event: MouseEvent): void => {
  if (!Capacitor.isNativePlatform()) {
    return;
  }

  // The module may have cancelled the click on purpose.
  if (event.defaultPrevented) {
    return;
  }

  const anchor = (event.target as Element | null)?.closest('a');
  if (anchor?.target !== '_blank') {
    return;
  }

  // The attribute is checked because the resolved `href` turns `//host` into an absolute URL.
  if (!isSafeHttpUrl(anchor.getAttribute('href'))) {
    return;
  }

  event.preventDefault();
  void openExternalMenuLink(anchor.href);
};
